<template>
  <div id="staff-salary">
    <div class="table-container">
      <el-table
        :data="salaryList"
        stripe
        style="width: 100%"
      >
        <el-table-column
          prop="report_name"
          label=""
        > </el-table-column>
        <el-table-column
          prop="contract_salary"
          label="薪资"
        >
        </el-table-column>
        <el-table-column
          prop="bonus"
          label="奖金"
        > </el-table-column>
        <el-table-column
          prop="allowance"
          label="补贴"
        > </el-table-column>
        <el-table-column
          prop="social_insurance"
          label="社保缴纳"
        >
        </el-table-column>
        <el-table-column
          prop="housing_fund"
          label="公积金"
        >
        </el-table-column>
        <el-table-column
          prop="income_tax"
          label="个人所得税"
        >
        </el-table-column>
        <el-table-column
          prop="deduct_for_leave"
          label="请假扣除"
        >
        </el-table-column>
        <el-table-column
          prop="deduct_for_late"
          label="迟到扣除"
        >
        </el-table-column>
        <el-table-column
          prop="extra"
          label="额外调整"
        > </el-table-column>
        <el-table-column
          prop="final_salary"
          label="实发薪资"
        >
        </el-table-column>
        <el-table-column
          prop="part_a_salary"
          label="基本工资"
        >
        </el-table-column>
        <el-table-column
          prop="part_b_salary"
          label="绩效工资"
        >
        </el-table-column>
      </el-table>
    </div>
    <div class="table-page">
      <el-pagination
        small
        layout="prev, pager, next"
        :total="total_count"
        :current-page="current_page"
        @current-change="getSalaryList"
        :page-size="10"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { staffSalaryReport } from '@/api/staff'
export default {
  name: 'staff-salary',
  components: {},
  data () {
    return {
      salaryList: [],
      total_count: 0,
      current_page: 1,
    }
  },
  mounted () {
    this.getSalaryList()
  },
  methods: {
    async getSalaryList () {
      let params = { page: this.current_page }
      const { code, result } = await staffSalaryReport(params)
      if (code === this.CONFIG.CODE_SUCCESS) {
        this.salaryList = result.list
        this.total_count = result.total_count
      }
    },
  },
}
</script>

<style lang="less" scoped>
.table-container {
  padding: 8px;
  background: #fff;
  border-radius: 5px;
}
.table-page {
  margin-top: 15px;
  text-align: center;
}
</style>
